import { Injectable } from '@angular/core';
import { ApiResponse } from '@core/interface/api-response.interface';
import { PageableResponse } from '@core/interface/pageable.interface';
import { RefId } from '@core/interface/ref-id.interface';
import { ManagementReportService } from '@core/services/entities/management-report.service';
import { CreateManagementReportRequestDto } from '@domain/management-report/dtos/create-management-report.request.dto';
import { ListManagementReportRequestDto } from '@domain/management-report/dtos/list-management-report.request.dto';
import { ManagementReportColumnCatalogResponseDto } from '@domain/management-report/dtos/management-report-column-catalog.response.dto';
import { ManagementReportSummaryResponseDto } from '@domain/management-report/dtos/management-report-summary.response.dto';
import { ManagementReportResponseDto } from '@domain/management-report/dtos/management-report.response.dto';
import { UpdateManagementReportRequestDto } from '@domain/management-report/dtos/update-management-report.request.dto';
import { ManagementReportRepository } from '@domain/management-report/repositories/management-report.repository';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ManagementReportRepositoryService implements ManagementReportRepository {
  constructor(private managementReportService: ManagementReportService) {}

  list(
    request: ListManagementReportRequestDto,
  ): Observable<ApiResponse<PageableResponse<ManagementReportResponseDto>>> {
    return this.managementReportService.list(request);
  }

  show(request: RefId): Observable<ApiResponse<ManagementReportResponseDto>> {
    return this.managementReportService.show(request);
  }

  create(
    request: CreateManagementReportRequestDto,
  ): Observable<ApiResponse<ManagementReportResponseDto>> {
    return this.managementReportService.create(request);
  }

  update(
    request: UpdateManagementReportRequestDto,
  ): Observable<ApiResponse<ManagementReportResponseDto>> {
    return this.managementReportService.update(request);
  }

  delete(request: RefId): Observable<ApiResponse<void>> {
    return this.managementReportService.delete(request);
  }

  summary(): Observable<ApiResponse<ManagementReportSummaryResponseDto>> {
    return this.managementReportService.summary();
  }

  getColumnCatalog(
    entityType: string,
  ): Observable<ApiResponse<ManagementReportColumnCatalogResponseDto>> {
    return this.managementReportService.getColumnCatalog(entityType);
  }

  duplicate(
    request: RefId,
  ): Observable<ApiResponse<ManagementReportResponseDto>> {
    return this.managementReportService.duplicate(request);
  }
}
